import request from '../../../shared/request'

export function getScheduleDrawingDates(job_id) {
  return request(`/job/schedules/${job_id}/drawings`)
}

export function updateScheduleDrawingDates(payload) {
  return request(`/job/schedules/${payload.job_id}/drawing`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function addScheduleDrawingDates(payload) {
  return request(`/job/schedules/${payload.job_id}/drawing`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteScheduleDrawing(payload) {
  return request(`/job/schedules/${payload.schedule_id}/drawing`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function updateScheduleDrawingNotes(payload) {
  return request(`/job/schedules/${payload.job_id}/drawings/drawings/notes`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/job/scheduleDrawings.js